import { DocumentIsogd } from "isogd-document-rest";

class DocumentTepViewController {
    private document: DocumentIsogd;
}

export const DocumentTepViewComponent: angular.IComponentOptions = {
    controller: DocumentTepViewController,
    template: require('./documentTepView.html'),
    bindings: {
        document: "<"
    }
};


// WEBPACK FOOTER //
// ./src/components/document/document-tep/documentTepView.ts